import Rails from '@rails/ujs';


document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('main').forEach(function(el) {
    el.addEventListener('scroll', function(e) {
      if (el.scrollTop >= el.scrollHeight - el.clientHeight - 100) {
        var search = el.querySelector('form.search-view');

        if (search && !search.classList.contains('searching')) {
          search.classList.add('searching');
          var page = search.querySelector('#page');
          page.value = parseInt(page.value) + 1;
          Rails.fire(search, 'submit');
        }
      }
    });
  });

});
